module.exports = __webpack_public_path__ + "static/media/1.fca9999f.svg";